<!-- 课程和文章上传公用组件-->
<template>
  <el-dialog
    :title="isCourse ? '课程设置' : '文章设置'"
    class="course-set"
    top="0"
    :visible="visible"
    :before-close="
      () => {
        visible = false;
      }
    "
  >
    <el-form
      :inline="true"
      ref="form"
      :model="form"
      label-width="80px"
      style="overflow: auto"
    >
      <el-form-item
        v-if="!isCourse"
        label="文章类别"
        style="margin-right: 410px"
      >
        <el-select v-model="form.category2" placeholder="请选择文章类别">
          <el-option
            v-for="item in articleTabs"
            :label="item.name"
            :value="item.id"
            :key="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else label="课程类别" style="margin-right: 410px">
        <el-select v-model="form.category2" placeholder="请选择课程类别">
          <el-option
            v-for="item in courseTabs"
            :label="item.name"
            :value="item.id"
            :key="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="阅读权限">
        <el-select
          value="金蝶集团内部可见"
          placeholder="请选择阅读权限"
          :disabled="true"
        >
          <el-option
            v-for="item in articlePermission"
            :label="item.desc"
            :value="item._id"
            :key="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="isCourse ? '课程标签' : '文章标签'"
        style="float: left"
      >
        <el-select
          v-model="tags"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请选择标签"
        >
          <el-option
            v-for="item in articleTags"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="封面" style="float: left">
        <common-upload
          picture="picture"
          @getdata="getArticleCoverPhoto"
          @removefile="removeCoverPhoto"
          accept=".jpg,.png,.gif,.JPG,.PNG,.GIF"
          type="image"
          tips="封面尺寸1070 * 482 像素"
          :fileList="coverPhotoList"
        />
      </el-form-item>
      <el-form-item label="上传附件" style="float: left">
        <common-upload
          buttonText="上传附件"
          tips="仅支持PDF格式"
          accept=".pdf"
          @removefile="removeAttachment"
          :fileList="attachementList"
          type="file"
          @getdata="getArticleAttach"
        />
      </el-form-item>
    </el-form>
    <div class="course-set-footer">
      <button
        class="ue-btn ue-btn-light"
        style="margin-right: 50px"
        @click="commitDraft"
      >
        暂存
      </button>
      <button
        class="ue-btn ue-btn-light"
        style="margin-right: 50px"
        @click="
          () => {
            visible = false;
          }
        "
      >
        返回编辑
      </button>
      <button
        class="ue-btn ue-btn-filling"
        style="width: 114px"
        @click="commitArticle"
      >
        提交评审
      </button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { courseTabs } from "../../../views/Course";
import { articleTabs } from "../../../views/Home";
export default {
  name: "course-set",
  data() {
    return {
      visible: false,
      courseTabs: courseTabs.splice(1),
      articleTabs: articleTabs.splice(1),
      courseDetail: null,
      tags: "",
      coverPhotoList: [],
      attachementList: [],
      form: {
        category2: "",
        permiss: "58bd105759ecf219c888f94d",
        coverPhoto: "",
        sourceFile: [],
        category: { _id: "588470ad08ec05162c2e18c1", name: "分类阅读" },
      },
    };
  },
  computed: {
    ...mapGetters("post", [
      "articlePermission",
      "articleTags",
      "category2",
      "post",
    ]),
    isCourse() {
      return this.courseDetail && this.courseDetail.articleType === "1";
    },
  },
  watch: {
    courseDetail(newVal) {
      if (!newVal) return;
      this.form = Object.assign(
        {},
        {
          category2:
            newVal.category2 && newVal.category2[0] && newVal.category2[0]._id,
          permiss: newVal.permiss,
          coverPhoto: newVal.coverPhoto,
          sourceFile: newVal.sourceFile || [],
          category: { _id: "588470ad08ec05162c2e18c1", name: "分类阅读" },
        }
      );
      if (newVal.coverPhoto) {
        this.coverPhotoList = [
          {
            name: "文章标题图",
            url: newVal.coverPhoto.url,
          },
        ];
      }
      (this.attachementList = newVal.sourceFile),
        (this.tags =
          newVal.tags &&
          newVal.tags.map((ele) => {
            return ele.value;
          }));
    },
  },
  methods: {
    ...mapActions("post", [
      "getArticlePermission",
      "getArticleTags",
      "getCategory2",
      "getSmallFileSrc",
      "savePost",
      "addTags",
      "submitPost",
    ]),
    async getArticleCoverPhoto(res) {
      try {
        this.form.coverPhoto = { url: res.data.url };
      } catch (error) {}
    },
    removeCoverPhoto() {
      this.form.coverPhoto = "";
    },
    getArticleAttach(res) {
      if (typeof res != "undefined") {
        let { url, data } = res.data;
        let uid = url.split("fileId=")[1];
        try {
          let file_name = Object.keys(data.files[0])[0];
          this.form.sourceFile.push({
            url: url,
            uid: uid,
            name: file_name,
          });
        } catch (error) {
          this.form.sourceFile.push({ url: url, uid: uid });
        }
      }
    },
    removeAttachment(uid) {
      this.form.sourceFile = Object.assign(
        [],
        this.form.sourceFile.filter((e) => e.uid !== uid)
      );
    },
    async commitArticle() {
      this.form.category2 = [{ _id: this.form.category2 }];
      let tags = [];
      for (let i = 0; i < this.tags.length; i++) {
        // 新增标签
        let element = this.tags[i];
        let hasTag = this.articleTags.find((ele) => ele._id === element);
        if (typeof hasTag === "undefined") {
          let _id = await this.addTags(element);
          tags[i] = {
            label: this.tags[i],
            value: _id,
          };
        } else {
          tags[i] = {
            label: hasTag.name,
            value: this.tags[i],
          };
        }
      }
      let course = { ...this.courseDetail, tags: tags, ...this.form };
      await this.savePost(course);
      await this.submitPost(this.courseDetail.obID);
      if (this.courseDetail.articleType === "1") {
        // 课程
        location.href = `/coursedetail/${this.courseDetail.obID}`;
      } else {
        // 文章
        location.href = `/p/${this.courseDetail.obID}`;
      }
    },
    async commitDraft() {
      this.visible = false;
      let tags = [];
      this.form.category2 = [{ _id: this.form.category2 }];
      for (let i = 0; i < this.tags.length; i++) {
        // 新增标签
        let element = this.tags[i];
        let hasTag = this.articleTags.find((ele) => ele._id === element);
        if (typeof hasTag === "undefined") {
          let _id = await this.addTags(element);
          tags[i] = {
            label: this.tags[i],
            value: _id,
          };
        } else {
          tags[i] = {
            label: hasTag.name,
            value: this.tags[i],
          };
        }
      }
      let course = { ...this.courseDetail, tags: tags, ...this.form };
      await this.savePost(course);
      await this.$message({
        showClose: true,
        message: "文章成功存为草稿",
        type: "success",
      });
    },
  },
  async mounted() {
    this.getArticleTags();
    await this.getArticlePermission();
    this.form.category2 = this.category2
      ? this.category2[0]._id
      : this.isCourse
      ? this.courseTabs[0].id
      : this.articleTabs[0].id;
    // if (!this.form.permiss) this.form.permiss = this.articlePermission[0]._id;
    this.form.permiss = "58bd105759ecf219c888f94d";
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.course-set {
  .course-set-title {
    text-align: left;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
  }
  .course-set-footer {
    margin-top: 36px;
  }
}
</style>
<style lang="scss">
.course-set {
  .el-dialog {
    width: 734px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
    border: 1px solid rgba(151, 151, 151, 1);
  }
}
.course-set.el-dialog__wrapper {
  min-height: 583px;
  top: 50%;
  margin-top: -291px;
}
</style>
